import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface NextMasteryTournament {
  id: number;
  name: string;
  date: string | null;
  time: string | null;
  fen: string | null;
  is_series_main_tournament: boolean;
  is_already_registered: boolean;
}

interface NextMasteryTournamentResponse {
  tournament: NextMasteryTournament | null;
}

const fetchNextMasteryTournament =
  async (): Promise<NextMasteryTournamentResponse> => {
    const response = await ChessRestClient.get(
      'subscription/v1/mastery-series/next-tournament/',
    );
    return response.data;
  };

export default function useGetNextMasteryTournament() {
  return useQuery<NextMasteryTournamentResponse, Error>(
    ['next-mastery-tournament'],
    fetchNextMasteryTournament,
    {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  );
}
